import Tilescape from './Tilescape';
import Environment from '../../common/Environment';

export default function Preload() {
  return (
    <Tilescape />
  );
};

export const Mount = () => {
  return (
    <>
      <Environment asset="landscape_environment" />
      <fogExp2
        attach="fog"
        density={ 0.0035 }
      />
    </>
  );
};